
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Pgforworkingprofessinalpune() {



    const cardData =
    {
        keyword: 'PG for Working Professionals Pune',
        heading: 'Shree Swami Samarth PG: PG for Working Professionals Pune',
        headingDescription: 'Shree Swami Samarth PG provides reliable and affordable PG for working professionals in Pune, offering a comfortable and well-managed stay close to major IT hubs and business centers. Designed to meet the lifestyle needs of employees and corporate teams, our PG rooms are fully furnished, spacious, and equipped with modern amenities like high-speed WiFi, 24x7 water supply, and CCTV security, ensuring both convenience and safety. We also serve hygienic home-cooked meals and provide regular housekeeping to make everyday living hassle-free. Strategically located in prime areas like  Balewadi, Hinjewadi, and Aundh, our PG ensures smooth connectivity to offices, public transport, and daily essentials. With disciplined management, affordable rent plans, and a peaceful environment, Shree Swami Samarth PG is the perfect choice for working professionals in Pune who seek comfort, reliability, and a homely atmosphere.',

        top: 'Top Facilities at Shree Swami Samarth PG ',

"topFacilities": [
  {
    "title": "Furnished Rooms Designed for Professionals",
    "description": "PGs in Pune for working professionals provide fully furnished rooms equipped with modern beds, spacious wardrobes, work desks, and ergonomic chairs. Single, twin, and triple sharing options are available depending on budget and privacy preferences. Interiors are kept simple, neat, and practical, creating a productive yet comfortable environment. Ample lighting, ventilation, and organized layouts make these rooms ideal for balancing long work hours with much-needed rest. These professional-friendly setups ensure residents feel at home while enjoying workplace-level convenience."
  },
  {
    "title": "Nutritious Meals for Busy Lifestyles",
    "description": "Working professionals benefit from hygienic, home-style meals included in most PG packages, saving valuable time otherwise spent on cooking or searching for food. Breakfast, lunch, and dinner are served on time to align with office schedules, ensuring residents maintain energy throughout the day. Kitchens follow strict cleanliness protocols, and some PGs offer multiple menu options for variety. With wholesome meals available daily, professionals can focus fully on their work commitments without compromising health."
  },
  {
    "title": "High-Speed Wi-Fi and Remote Work Support",
    "description": "Recognizing the digital needs of today’s workforce, PGs for professionals in Pune provide reliable high-speed Wi-Fi across rooms and common areas. Residents can easily manage remote work, attend video calls, and complete projects without connectivity issues. Many PGs also feature quiet coworking zones or lounges to replicate an office-like atmosphere. With uninterrupted internet and power backup, professionals can maintain productivity and meet deadlines from the comfort of their accommodation."
  },
  {
    "title": "24/7 Security and Professional Safety",
    "description": "Safety and discipline are top priorities in PGs for working professionals, with facilities such as CCTV surveillance, biometric entry, and round-the-clock staff presence. Visitor entry is strictly regulated to ensure privacy and a secure environment. Located in safe residential and commercial hubs across Pune, these PGs provide peace of mind for both residents and their families. A secure environment allows professionals to focus on career growth without distractions or worries."
  },
  {
    "title": "Prime Locations Near IT Parks and Offices",
    "description": "PGs for professionals in Pune are strategically located near major IT parks, business hubs, and commercial centers. Popular areas like  Hinjewadi, Viman Nagar, and Kharadi offer quick access to corporate offices, reducing commuting time. Public transport, cabs, and metro connectivity make daily travel convenient and hassle-free. Staying in these locations allows residents to balance work life with easy access to gyms, shopping malls, and restaurants, creating a complete urban lifestyle."
  },
  {
    "title": "Housekeeping and Laundry Services",
    "description": "To reduce the burden of daily chores, most PGs include regular housekeeping and laundry services. Rooms and bathrooms are cleaned routinely, and garbage disposal is managed effectively. Many PGs provide washing machines or professional laundry facilities, making it convenient for professionals with tight schedules. These services ensure a hygienic and organized living environment, helping residents save time and energy for work and personal growth."
  },
  {
    "title": "Community Living and Networking Opportunities",
    "description": "PGs in Pune often attract like-minded working professionals, creating opportunities for networking and collaboration. Shared lounges, dining areas, and recreational spaces encourage interaction and bonding. Many PGs organize weekend activities, community dinners, or fitness sessions, offering a balance between professional life and social engagement. This sense of community helps residents unwind, make friends, and expand their professional and personal circles while living away from home."
  },
  {
    "title": "Affordable and Transparent Rent Plans",
    "description": "PGs for working professionals in Pune are available at competitive monthly rents that typically include meals, Wi-Fi, and housekeeping. Shared rooms range from ₹7,000 to ₹10,000/month, while single occupancy in premium PGs can cost ₹15,000–₹20,000/month depending on location and amenities. Transparent rental policies ensure there are no hidden charges, making financial planning easier. This affordability, paired with professional-friendly facilities, makes PGs an ideal choice for those seeking comfort and convenience in Pune."
  }
],


"services": [
  {
    "name": "PG for Working Professionals Pune",
    "description": "Shree Swami Samarth PG offers thoughtfully designed PG accommodations for working professionals in Pune. With peaceful surroundings, flexible rental terms, nutritious meals, and fast internet, our PG is tailored to support busy professionals who seek a no-compromise living experience close to their workplaces."
  },
  {
    "name": "Executive PG in Pune",
    "description": "Our Executive PG in Pune is ideal for senior-level employees or individuals seeking a premium co-living environment. Shree Swami Samarth PG features air-conditioned rooms, smart TVs, private workspaces, attached bathrooms, and top-notch housekeeping, ensuring comfort and convenience for executives living away from home."
  },
  {
    "name": "Co-living PG in Pune",
    "description": "Experience modern co-living with Shree Swami Samarth PG in Pune. Our co-living spaces combine privacy with community, offering well-furnished shared flats, common lounges, work zones, and regular housekeeping. Perfect for professionals who want flexibility, amenities, and a social vibe in their living space."
  },
  {
    "name": "PG Near IT Parks Pune",
    "description": "Located near key IT parks like Hinjewadi,  and Balewadi, our PG makes daily commutes quick and easy. Shree Swami Samarth PG is perfect for tech professionals who want to avoid traffic and live just minutes away from their offices, with all essential services included in one monthly rent."
  },
  {
    "name": "Shared PG for Professionals in Pune",
    "description": "Shree Swami Samarth PG offers shared accommodations specifically designed for working professionals. Our 2- and 3-sharing rooms provide a budget-friendly way to live with like-minded individuals, with daily meals, fast Wi-Fi, cleaning services, and professional management ensuring a stress-free stay."
  },
  {
    "name": "Single Room PG for Working Professionals Pune",
    "description": "Prefer your own space? Our single room PG options in Pune are ideal for working professionals who value privacy. Each room is furnished with a bed, desk, wardrobe, and attached washroom—giving you comfort, quiet, and all the convenience of a home close to your office."
  },
  {
    "name": "PG with Workstation in Pune",
    "description": "Work-from-home made easy with our PG rooms featuring in-built workstations. Shree Swami Samarth PG ensures every room has a designated desk and chair setup, strong Wi-Fi, and a quiet environment—perfect for professionals working hybrid or remote jobs in Pune."
  },
  {
    "name": "PG Near Office Hubs Pune",
    "description": "Stay just minutes away from Pune’s corporate and office hubs with Shree Swami Samarth PG. Our properties are located in business-centric zones like  Aundh, and Hinjewadi, offering fully equipped rooms, daily food, laundry, and transport convenience for working individuals."
  },
  {
    "name": "Furnished PG for Professionals Pune",
    "description": "Move in without lifting a finger—our fully furnished PGs for professionals in Pune come with ready-to-use beds, wardrobes, study tables, and appliances. Shree Swami Samarth PG ensures your stay is seamless with modern interiors, clean utilities, and maintenance taken care of."
  },
  {
    "name": "Monthly PG for Working People Pune",
    "description": "Shree Swami Samarth PG offers monthly rental PGs for working individuals in Pune, with no long-term lock-ins. Pay monthly and enjoy inclusive services like meals, Wi-Fi, and laundry. Ideal for transferable jobs, probationary employees, and remote workers seeking flexibility."
  }
],
"tableData": [
  ["PG for Working Professionals Pune", "Executive PG in Pune"],
  ["Co-living PG in Pune", "PG Near IT Parks Pune"],
  ["Shared PG for Professionals in Pune", "Single Room PG for Working Professionals Pune"],
  ["PG with Workstation in Pune", "PG Near Office Hubs Pune"],
  ["Furnished PG for Professionals Pune", "Monthly PG for Working People Pune"]
],




"whychoose": [
    {
        "WhyChooseheading": "Premium PG in Pune for Working Professionals",
        "WhyChoosedescription": "Shree Swami Samarth PG offers thoughtfully designed PG accommodations in Pune that cater specifically to the needs of working professionals. With furnished rooms, high-speed Wi-Fi, nutritious meals, and a peaceful environment, our PG is ideal for professionals who value comfort and convenience after a busy workday."
    },
    {
        "WhyChooseheading": "Strategic Locations Close to IT Parks and Business Hubs",
        "WhyChoosedescription": "Our PGs are located in Pune’s prime areas like  Aundh, and Balewadi, close to Hinjewadi IT Park, commercial complexes, and coworking spaces. Easy access to public transport, shared cabs, and metro connectivity ensures minimal commute time and more productivity."
    },
    {
        "WhyChooseheading": "Fully Furnished Rooms with a Professional Touch",
        "WhyChoosedescription": "Every room is furnished to meet the needs of a modern working individual—featuring a bed, wardrobe, work desk, and fast Wi-Fi for remote work or after-hours tasks. Whether you prefer a private space or a shared one, we offer flexible room-sharing options."
    },
    {
        "WhyChooseheading": "Nutritious Meals That Fit Your Schedule",
        "WhyChoosedescription": "We provide homely, freshly prepared meals three times a day—served on time and in a clean dining area. Whether you work night shifts or follow standard office hours, our meal timings are adaptable to your work routine, helping you stay healthy and well-fed."
    },
    {
        "WhyChooseheading": "Peaceful and Professional Environment",
        "WhyChoosedescription": "Our PG is designed to offer a calm, professional setting where you can relax, focus, and recharge. No unnecessary noise or disturbances—just a clean, well-managed space where working professionals can unwind after a long day."
    },
    {
        "WhyChooseheading": "All-Inclusive Rent with Zero Hidden Charges",
        "WhyChoosedescription": "The monthly rent covers everything—accommodation, food, Wi-Fi, laundry, electricity, housekeeping, and maintenance. There are no brokerage fees or surprise costs, making it easy to budget and manage your finances with clarity and confidence."
    },
    {
        "WhyChooseheading": "Strong Focus on Hygiene and Cleanliness",
        "WhyChoosedescription": "Our staff maintains strict hygiene protocols with daily room cleaning, sanitization of common areas, and regular kitchen inspections. You can expect a tidy and well-kept environment that reflects the standards of professional living."
    },
    {
        "WhyChooseheading": "Round-the-Clock Support and Assistance",
        "WhyChoosedescription": "We offer 24/7 support for any maintenance issues, emergencies, or general assistance. Our trained staff ensures that your stay is smooth and worry-free—allowing you to focus entirely on your career and personal growth."
    }
]



















    }

const faqData = [
    {
        question: "How can I book a PG for working professionals in Pune at Shree Swami Samarth PG?",
        answer: "You can book a PG for working professionals by contacting us at +91 9594917913 or visiting our property. We also assist with virtual tours and online bookings."
    },
    {
        question: "What facilities are available for working professionals at your PG in Pune?",
        answer: "Our PG offers fully furnished rooms, high-speed Wi-Fi, power backup, daily housekeeping, laundry service, hot water, vegetarian meals, and 24/7 CCTV security."
    },
    {
        question: "Is the PG location convenient for office commutes in Pune?",
        answer: "Yes, our PG is strategically located near key business hubs like  Hinjewadi, Aundh, and Balewadi for hassle-free commutes."
    },
    {
        question: "Is food included in the PG rent for working professionals?",
        answer: "Yes, we provide freshly prepared vegetarian meals—breakfast, lunch, and dinner—all included in the monthly rent."
    },
    {
        question: "Are the rooms private or shared for working professionals?",
        answer: "We offer flexible room options including single, double, and triple sharing based on your preference and budget."
    },
    {
        question: "Is there a quiet and professional living environment at the PG?",
        answer: "Yes, we maintain a calm and disciplined environment, ideal for working professionals looking to relax after work."
    },
    {
        question: "Do you provide any guest or visitor policy for professionals?",
        answer: "Yes, we have a structured guest policy in place for the comfort and safety of all residents. Details can be discussed during booking."
    },
    {
        question: "What is the monthly rent for PG accommodation for working professionals in Pune?",
        answer: "The rent varies depending on room type and amenities. Please contact us for updated pricing and offers."
    },
    {
        question: "Is a security deposit required for booking the PG?",
        answer: "Yes, a refundable security deposit is required. The amount depends on the room type selected."
    },
    {
        question: "How do I contact Shree Swami Samarth PG for working professional PG bookings in Pune?",
        answer: "Call us at +91 9594917913 for availability, pricing, and scheduling a visit to our PG property."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Aniket Deshmukh',
        designation: 'Business Analyst, Hinjewadi Phase 2',
        rating: [1, 1, 1, 1, 1],
        text: '“This PG is excellent for working professionals. It’s close to the IT parks, the food is great, and the rooms are clean and peaceful.”',
    },
    {
        name: 'Ms. Pooja Thakur',
        designation: 'HR Executive, Balewadi High Street',
        rating: [1, 1, 1, 1, 1],
        text: '“As a working woman, I found the PG extremely safe and convenient. Great service, clean environment, and a supportive staff.”',
    },
];






















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9209169761",
            "+91 9096665072",

        ],
        email: "reservation@swamisamarthpg.com "
    };


     const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " PG in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "  Single Room PG in Pune",
        },
        
        {
            place: "/images/keyword/4.jpg",
            text: "  Best Luxury PG in Pune",
        },
       
       
        {
            place: "/images/keyword/13.jpg",
            text: "  Hostel in Pune",
        },

        {
            place: "/images/keyword/15.jpg",
            text: " PG for Working Professionals Pune",
        },
        
        {
            place: "/images/keyword/19.jpg",
            text: "  Paying Guest Near Hinjewadi IT Park Pune",
        },
        

    ];


    const images = [
        { src: "./images/gallery/1.jpg", alt: "Image 1" },
        { src: "./images/gallery/2.jpg", alt: "Image 1" },
        { src: "./images/gallery/3.jpg", alt: "Image 1" },
        { src: "./images/gallery/4.jpg", alt: "Image 1" },
        { src: "./images/gallery/5.jpg", alt: "Image 1" },
        { src: "./images/gallery/6.jpg", alt: "Image 1" },
        { src: "./images/gallery/7.jpg", alt: "Image 1" },
        { src: "./images/gallery/8.jpg", alt: "Image 1" },
        { src: "./images/gallery/9.jpg", alt: "Image 1" },

    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "PG for Working Professionals Pune",
  "image": "https://swamisamarthpg.com/assets/images/pg-working-professionals-pune.jpg", // Replace with actual image URL
  "description": "Comfortable and furnished PG accommodations in Pune for working professionals. Options include single rooms, shared PG, co-living spaces, and proximity to IT parks and office hubs with monthly rent plans.",
  "brand": {
    "@type": "Brand",
    "name": "Shree Swami Samarth PG"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1700"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9000",  // Replace with actual price if needed
    "availability": "https://schema.org/InStock",
    "url": "https://swamisamarthpg.com/pg-for-working-professionals-pune"  // Replace with actual page URL if different
  }
};






    return (
        <div>
<Helmet>
  <title>PG for Working Professionals Pune | Furnished & Executive PG</title>
  <meta 
    name="description" 
    content="Find furnished and comfortable PG accommodations in Pune for working professionals. Options include single rooms, shared PG, co-living, and locations near IT parks and office hubs." 
  />
  <meta 
    name="keywords" 
    content="PG for Working Professionals Pune, Executive PG in Pune, Co-living PG in Pune, PG Near IT Parks Pune, Shared PG for Professionals in Pune, Single Room PG for Working Professionals Pune, PG with Workstation in Pune, PG Near Office Hubs Pune, Furnished PG for Professionals Pune, Monthly PG for Working People Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/16.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF6403', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topFacilities.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                          

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Shree Swami Samarth PG</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                {/* <FAQKeyword faqs={faqData} /> */}
                <Accordion data={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF6403',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF6403' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919209169761" className="d-block  text-white">+91 9209169761</a>
                                                <a href="tel:+919096665072" className="d-block  text-white">+91 9096665072</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:reservation@swamisamarthpg.com " className=" text-white d-block">
                                                    reservation@swamisamarthpg.com 
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Shree Swami Samarth PG  <br />
                                                        M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Pgforworkingprofessinalpune;